import FindologicTracker from './interface';
import func from '../../func';
import network from '../../network';

/**
 * Tracker using the Beacon API to send asynchronous tracking requests in the background.
 *
 * @constructor
 * @augments FindologicTracker
 */
export default function BeaconTracker(config) {
    FindologicTracker.call(this, config);

    /**
     * Sends a tracking request using a Beacon API.
     *
     * @param {string} url The URL to send the tracking request to.
     * @param {string} data Tracking data to transmit.
     * @param {function} callback The callback that's being called immediately, because Beacon requests are
     *      processed in the background and continue beyond page changes.
     */
    this.send = function (url, data, callback) {
        network.sendBeacon(url, data);
        func.undefinedToNoOp(callback)();
    };
}
